import { Pipe, PipeTransform } from '@angular/core';
import { Dict, DictList } from '@nk/utils-lib';

@Pipe({
  name: 'getDictValue',
  standalone: false,
})
export class GetDictValuePipe implements PipeTransform {
  public transform<T>(dict: Dict<T> | DictList<T>, key: string): T | T[] {
    return dict[key];
  }
}
